/**
 * @generated SignedSource<<0bd68afaf3672935c649173bdd9aba7f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type BookingSource = "CUSTOMER" | "EVENT" | "GOLF_GENIUS" | "MEMBER" | "PACESETTER" | "STAFF" | "SUPREME" | "TOURNAMENT_MANAGEMENT";
export type BookingStatus = "CONFIRMED" | "DRAFT";
export type PaymentSource = "CASH" | "NONCE" | "RAINCHECK" | "SQUARE_CARD_ON_FILE" | "SQUARE_GIFT_CARD" | "SQUARE_HOUSE_ACCOUNT";
export type PaymentStatus = "APPROVED" | "CANCELED" | "COMPLETED" | "FAILED" | "PENDING";
export type PrePaymentRequirement = "COLLECT_CARD_ON_FILE" | "FULL" | "NONE";
import { FragmentRefs } from "relay-runtime";
export type BookingPaymentMethodSelect_booking$data = {
  readonly __typename: string;
  readonly canUpdate: boolean | null | undefined;
  readonly orders: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly orderPayments: {
          readonly edges: ReadonlyArray<{
            readonly node: {
              readonly paymentSource: PaymentSource | null | undefined;
              readonly status: PaymentStatus | null | undefined;
            } | null | undefined;
          } | null | undefined> | null | undefined;
        } | null | undefined;
      } | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
  readonly paymentCardOnFile: {
    readonly " $fragmentSpreads": FragmentRefs<"PaymentMethod_squareCardOnFile">;
  } | null | undefined;
  readonly paymentRequirements: {
    readonly prePaymentRequirement: PrePaymentRequirement;
    readonly requirePaymentCardOnFile: boolean;
  } | null | undefined;
  readonly source: BookingSource | null | undefined;
  readonly startSlot: {
    readonly agenda: {
      readonly date: string;
    };
  } | null | undefined;
  readonly status?: BookingStatus;
  readonly " $fragmentType": "BookingPaymentMethodSelect_booking";
};
export type BookingPaymentMethodSelect_booking$key = {
  readonly " $data"?: BookingPaymentMethodSelect_booking$data;
  readonly " $fragmentSpreads": FragmentRefs<"BookingPaymentMethodSelect_booking">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v1 = [
  (v0/*: any*/)
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "BookingPaymentMethodSelect_booking",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "BookingPaymentRequirements",
      "kind": "LinkedField",
      "name": "paymentRequirements",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "requirePaymentCardOnFile",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "prePaymentRequirement",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "__typename",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "source",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "canUpdate",
      "storageKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": (v1/*: any*/),
      "type": "StandardBooking",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": (v1/*: any*/),
      "type": "LessonBooking",
      "abstractKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "SquareCardOnFile",
      "kind": "LinkedField",
      "name": "paymentCardOnFile",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PaymentMethod_squareCardOnFile"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "OrderConnection",
      "kind": "LinkedField",
      "name": "orders",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "OrderEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Order",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "OrderPaymentConnection",
                  "kind": "LinkedField",
                  "name": "orderPayments",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "OrderPaymentEdge",
                      "kind": "LinkedField",
                      "name": "edges",
                      "plural": true,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "OrderPayment",
                          "kind": "LinkedField",
                          "name": "node",
                          "plural": false,
                          "selections": [
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "paymentSource",
                              "storageKey": null
                            },
                            (v0/*: any*/)
                          ],
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "startSlot",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Agenda",
          "kind": "LinkedField",
          "name": "agenda",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "date",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Booking",
  "abstractKey": "__isBooking"
};
})();

(node as any).hash = "38b6d8ec778311c18808898891223476";

export default node;
